<script setup lang="ts">
defineProps({
  fields: {
    type: Object as PropType<Record<string, any>>,
    default: () => {},
  },
})
defineSlice({

  name: { label: 'Magazine Slide', group: 'Magazine', layouts: ['Atlantisbahamas', 'NPIWFF', 'Empty', 'AtlantisMobileApp'] },
  preview: 'SlicesGlueMagazineSliderMagazineSlide.jpg',
  description: 'Magazine Slide',
  tags: ['Image'],
  fields: {
    image: {
      label: 'Image',
      type: 'media',
      editorLabel: true,
      breakpoints: {
        lg: { width: 1600, height: 760 },
        md: { width: 400, height: 720 },
      },
      group: 'Image',
    },
    imagePosition: {
      label: 'Image Position',
      type: 'select',
      options: { top: 'Top', center: 'Center', bottom: 'Bottom' },
      default: 'top',
      group: 'Image',
    },
    isRight: { label: 'Title Right?', type: 'checkbox' },
    isCompact: { label: 'Title Compact?', type: 'checkbox', default: false },
    subTitle: { label: 'Sub-Title', type: 'text' },
    title: { label: 'Title', type: 'text' },
    description: { label: 'Description', type: 'textarea' },
    link: { label: 'Link', type: 'link', enabled: false },
    wistiaId: { type: 'text', label: 'Wistia ID' },
    cardColor: { type: 'color', label: 'Card Background Color' },
  },
  templates: [{
    label: 'Magazine Slide',
    fields: {
      description: { value: 'Learn how Atlantis continues to lead the charge toward a sustainable future in The Bahamas.' },
      image: { value: 'https://atlantis-cms-assets.s3.us-east-2.amazonaws.com/media/glue/home/home-bg-scaled.jpg' },
      isRight: { value: true },
      link: { value: { text: 'Learn More', target: '_blank', relationship: null, href: '/new-page' } },
      subTitle: { value: 'Atlantis' },
      title: { value: 'MAKING WAVES' },
    },
  }],
})
</script>

<template>
  <div class="w-full relative  aspect-video  max-h-[600px] text-white">
    <div class="md:hidden w-full aspect-video overflow-hidden">
      <VoixMedia :field="fields.image" class="w-full h-full object-cover" />
    </div>
    <VoixMedia v-slot="slotProps" :field="fields.image" background class="hidden md:block">
      <div
        class="md:bg-cover md:absolute md:inset-0 z-30 px-6 lg:px-24" :class="{
          'bg-center': fields.imagePosition.value === 'center',
          'bg-bottom': fields.imagePosition.value === 'bottom',
        }" :style="{ backgroundImage: `url(${slotProps.image})` }"
      >
        <div>
          <div class="hidden md:block absolute z-0 bottom-0 left-0 right-0 bg-gradient-transparent-black" style="height: 100%" />
          <div
            v-if="fields.wistiaId.value"
            class="md:absolute inset-0 z-10 text-white flex justify-center items-center cursor-pointer"
          >
            <div
              class="rounded-full flex justify-center items-center -mt-8" style="
                height: 3rem;
                width: 3rem;
                box-shadow: 0 0 1px 0px white inset, 0 0 1px 1px white;
              "
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-4 text-white" viewBox="0 0 30.594 31.625">
                <path style="fill: currentcolor" d="M62,66V96L91,81Z" transform="translate(-61.5 -65.188)" />
              </svg>
            </div>
          </div>
          <div
            v-if="fields.wistiaId.value"
            class="md:absolute inset-0 z-50 text-white  flex justify-center items-center"
          >
            <glue-media-wistia
              :video-id="fields.wistiaId.value" relative-or-absolute="absolute"
              class=" inset-0 bg-black"
            />
          </div>
        </div>
      </div>
    </VoixMedia>
    <div v-if="fields.title.value" class="md:absolute z-30 md:bottom-0 md:left-0 md:right-0">
      <div class="container mx-auto sm:grid sm:grid-cols-6 lg:grid-cols-12 lg:gap-16">
        <div
          class="bg-glueblue-600 p-12 md:translate-y-24 sm:col-span-8 lg:col-span-4 xl:col-span-3"
          :class="{ 'lg:col-start-9': fields.isRight.value }"
          :style="{ backgroundColor: fields.cardColor.value }"
        >
          <div class="headline-3">
            <div class="subtitle ">
              <span>{{ fields.subTitle.value }}</span>
            </div>
            {{ fields.title.value }}
          </div>
          <div v-if="fields.description.value" class="mt-4 font-light text-[17px] antialiased">
            {{ fields.description.value }}
          </div>
          <a
            v-if="fields.link.enabled"
            class="group mt-8 inline-block btn btn-text text-xs"
            :href="fields.link.value?.href"
            :target="fields.link.value.target"
          >
            {{ fields.link.value.text }}
            <Icon name="heroicons:arrow-long-right-solid" class="group-hover:translate-x-2 duration-300 inline-block w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
